module.exports = __webpack_public_path__ + "img/eyyb-t1.023177a3.jpg";